<div id="acc-root" class="acc-overlay" (click)="close.emit()">
  <section class="acc-card" role="dialog" aria-modal="true" aria-labelledby="acc-title" (click)="$event.stopPropagation()">

    <!-- Vue liste des utilisateurs -->
    <div *ngIf="!selectedUser()" class="acc-list-view">
      <div class="acc-header">
        <div>
          <h2 id="acc-title">{{ 'components.userListModal.header.title' | translate }}</h2>
          <p class="acc-subtitle">{{ 'components.userListModal.header.subtitle' | translate }}</p>
        </div>
        <button type="button" class="acc-close" (click)="close.emit()" [attr.aria-label]="'components.userListModal.header.closeAriaLabel' | translate">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div *ngIf="loading()" class="acc-state">{{ 'components.userListModal.loading' | translate }}</div>

      <div *ngIf="!loading()" class="acc-body">
        <div class="user-rows">
          <div class="user-row" *ngFor="let user of paginatedUsers()">
            <div class="user-avatar" [ngStyle]="avatarStyle(user)">{{ initials(user) }}</div>

            <div class="user-info">
              <div class="user-name">{{ user.first_name }} {{ user.last_name }}</div>
              <div class="user-email">{{ user.email }}</div>
              <div class="user-meta">
                <span class="badge mu" *ngIf="jobTitleLabel(user) as jt; else createdAt">{{ jt }}</span>
                <ng-template #createdAt>
                  <span class="badge mu">{{ 'components.userListModal.createdAtLabel' | translate }} {{ user.created_at | date:'dd/MM/yyyy' }}</span>
                </ng-template>
                <span class="badge mu" *ngIf="user.last_login_at">{{ 'components.userListModal.loginAtLabel' | translate }} {{ user.last_login_at | date:'dd/MM/yyyy HH:mm' }}</span>
                <span class="badge mu" *ngIf="!user.last_login_at">{{ 'components.userListModal.neverLoggedIn' | translate }}</span>
              </div>
            </div>

            <div class="user-actions">
              <button type="button" class="icon-btn" (click)="editUser(user)" [title]="'components.userListModal.editAction' | translate">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
              <button type="button" class="icon-btn icon-btn--danger" (click)="deleteUser(user)" [title]="'components.userListModal.deleteAction' | translate">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                </svg>
              </button>
            </div>
          </div>

          <div *ngIf="paginatedUsers().length === 0" class="acc-state">{{ 'components.userListModal.emptyState' | translate }}</div>
        </div>

        <div *ngIf="totalPages() > 1" class="pagination">
          <button type="button" class="page-btn" [disabled]="currentPage() === 0" (click)="previousPage()">{{ 'components.userListModal.pagination.previous' | translate }}</button>
          <span class="page-info">{{ 'components.userListModal.pagination.info' | translate:{ current: currentPage() + 1, total: totalPages() } }}</span>
          <button type="button" class="page-btn" [disabled]="currentPage() === totalPages() - 1" (click)="nextPage()">{{ 'components.userListModal.pagination.next' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Vue modification des droits -->
    <div *ngIf="selectedUser()" class="acc-edit-view">
      <div class="acc-header">
        <div class="acc-header-with-back">
          <button type="button" class="acc-back-btn" (click)="backToList()" [title]="'components.userListModal.editHeader.backAriaLabel' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2 id="acc-title">{{ 'components.userListModal.editHeader.title' | translate }}</h2>
        </div>
        <button type="button" class="acc-close" (click)="close.emit()" [attr.aria-label]="'components.userListModal.editHeader.closeAriaLabel' | translate">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="acc-body">
        <form [formGroup]="userForm" (ngSubmit)="saveUser()" class="user-form">
          <div class="field-row">
            <div class="field-group">
              <label class="field-label" for="first_name">{{ 'components.userListModal.fields.firstName' | translate }}</label>
              <input
                id="first_name"
                type="text"
                formControlName="first_name"
                class="field-input"
                [class.error]="userForm.get('first_name')?.invalid && userForm.get('first_name')?.touched"
              />
              <span class="field-error" *ngIf="userForm.get('first_name')?.invalid && userForm.get('first_name')?.touched">
                {{ 'components.userListModal.fields.firstNameError' | translate }}
              </span>
            </div>

            <div class="field-group">
              <label class="field-label" for="last_name">{{ 'components.userListModal.fields.lastName' | translate }}</label>
              <input
                id="last_name"
                type="text"
                formControlName="last_name"
                class="field-input"
                [class.error]="userForm.get('last_name')?.invalid && userForm.get('last_name')?.touched"
              />
              <span class="field-error" *ngIf="userForm.get('last_name')?.invalid && userForm.get('last_name')?.touched">
                {{ 'components.userListModal.fields.lastNameError' | translate }}
              </span>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label" for="email">{{ 'components.userListModal.fields.email' | translate }}</label>
            <input
              id="email"
              type="email"
              formControlName="email"
              class="field-input"
              [class.error]="userForm.get('email')?.invalid && userForm.get('email')?.touched"
            />
            <span class="field-error" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
              {{ 'components.userListModal.fields.emailError' | translate }}
            </span>
          </div>

          <div class="field-group">
            <label class="field-label">{{ 'components.userListModal.fields.language' | translate }}</label>
            <app-language-select formControlName="locale" [ariaLabel]="'components.userListModal.fields.language' | translate"></app-language-select>
          </div>

          <div class="perm-section">
            <div class="perm-title">{{ 'components.userListModal.permissions.title' | translate }}</div>
            <div class="perm-grid">
              <button
                type="button"
                *ngFor="let perm of visiblePermissions"
                class="perm-chip"
                [class.active]="hasPermission(perm.key)"
                (click)="togglePermission(perm.key)">
                {{ perm.label }}
              </button>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn--ghost" (click)="backToList()" [disabled]="saving()">{{ 'components.userListModal.actions.cancel' | translate }}</button>
            <button type="submit" class="btn btn--primary" [disabled]="saving()">
              {{ saving() ? ('components.userListModal.actions.saving' | translate) : ('components.userListModal.actions.save' | translate) }}
            </button>
          </div>
        </form>
      </div>
    </div>

  </section>
</div>

<!-- Modale de confirmation -->
<app-confirm-modal
  *ngIf="showConfirmModal()"
  [title]="'components.userListModal.confirmEdit.title' | translate"
  [message]="'components.userListModal.confirmEdit.message' | translate"
  [confirmText]="'components.userListModal.actions.save' | translate"
  [cancelText]="'components.userListModal.actions.cancel' | translate"
  (confirm)="confirmSave()"
  (cancel)="cancelSave()">
</app-confirm-modal>

<!-- Modale de confirmation suppression -->
<app-confirm-modal
  *ngIf="showDeleteModal()"
  [title]="'components.userListModal.confirmDelete.title' | translate"
  [message]="'components.userListModal.confirmDelete.message' | translate:{ firstName: $safeNavigationMigration(userToDelete()?.first_name), lastName: $safeNavigationMigration(userToDelete()?.last_name) }"
  [confirmText]="'components.userListModal.deleteAction' | translate"
  [cancelText]="'components.userListModal.actions.cancel' | translate"
  (confirm)="confirmDelete()"
  (cancel)="cancelDelete()">
</app-confirm-modal>
